import { EPayoutType } from "@rentiohq/shared-frontend/dist/types/payment.types";
import {
  ERentDepositStatus,
  IRentDeposit,
} from "@rentiohq/shared-frontend/dist/types/rentDeposit.types";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { ETagVariant } from "@rentiohq/web-shared-next/dist/ui-components";
import { ts } from "services";

export const getStatusVariation = (status: ERentDepositStatus) => {
  switch (status) {
    case ERentDepositStatus.Established:
    case ERentDepositStatus.Released:
    case ERentDepositStatus.BanqupPendingPayment:
      return ETagVariant.Success;

    case ERentDepositStatus.VerifyingRentDepositHolder:
    case ERentDepositStatus.WaitingForVerificationByBanqup:
    case ERentDepositStatus.RequestingBanqupAccount:
      return ETagVariant.Default;

    case ERentDepositStatus.Cancelled:
    case ERentDepositStatus.PayingOut:
      return ETagVariant.Error;

    default:
      return ETagVariant.Warning;
  }
};

const getPaymentMethodFromRentDepositPo = (rentDeposit: IRentDeposit) => {
  if (!rentDeposit.paymentOrder) {
    return;
  }

  if (!rentDeposit.paymentOrder.paymentRequests?.length) {
    return;
  }

  const paidPayout = rentDeposit.paymentOrder.paymentRequests.find(
    paymentRequest => paymentRequest.payoutType === EPayoutType.Charge,
  );

  return paidPayout?.paymentMethod;
};

export const getRentDepositStatus = (rentDeposit: IRentDeposit) => {
  if (rentDeposit.status === ERentDepositStatus.BanqupPendingPayment) {
    const paymentMethod = getPaymentMethodFromRentDepositPo(rentDeposit);

    return getLocalizedText(
      `follow_up.rent_deposits.filter.status.${rentDeposit.status.toLowerCase()}.label`,
      {
        paymentMethod: paymentMethod
          ? getLocalizedText(`payment_request.method.${paymentMethod}`)
          : getLocalizedText("system.unknown"),
      },
    );
  }

  return ts.followUpRentDepositsFilterStatusLabel({
    extra: { key: rentDeposit.status },
  });
};
